<template>
  <swiper
    :options="swiperOption"
    ref="mySwiper"
    class="mobile-wrapper"
    :style="`height:${height}px;max-width:750px;margin:0 auto;`"
  >
    <swiper-slide>
      <img src="../../../assets/img/mobile/1.jpg">
      <div class="download">
        <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.zaiart.yi"></a>
      </div>
      <div class="next" @click="next"></div>
    </swiper-slide>
    <swiper-slide>
      <img src="../../../assets/img/mobile/2.png">
      <div class="next" @click="next"></div>
    </swiper-slide>
    <swiper-slide>
      <img src="../../../assets/img/mobile/3.png">
      <div class="next" @click="next"></div>
    </swiper-slide>
    <swiper-slide>
      <img src="../../../assets/img/mobile/4.png">
      <div class="next" @click="next"></div>
    </swiper-slide>
    <swiper-slide>
      <img src="../../../assets/img/mobile/5.png">
      <div class="download" style="bottom:16px">
        <a href="http://a.app.qq.com/o/simple.jsp?pkgname=com.zaiart.yi"></a>
      </div>
    </swiper-slide>
  </swiper>
</template>
<script>
import 'swiper/dist/css/swiper.css'
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {
  name: 'mobile',
  components: { swiper, swiperSlide },
  data: () => ({
    height: 'auto',
    swiperOption: {
      direction: 'vertical',
      slidesPerView: 1,
      mousewheel: true
    }
  }),
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper
    }
  },
  methods: {
    next() {
      this.swiper && this.swiper.slideNext()
    }
  },
  created() {
    // 获取可视区高度
    this.height = document.documentElement.clientHeight
  }
}
</script>
<style scoped>
@keyframes arrow {
  0% {
    transform: translate(0, -0.1rem);
    opacity: 0;
  }
  20% {
    transform: translate(0, -0.05rem);
    opacity: 1;
  }
  100% {
    transform: translate(0, 0);
    opacity: 0;
  }
}
html,
body {
  position: relative;
  height: 100%;
}
.mobile-wrapper {
  width: 100%;
  height: 100%;
}
.mobile-wrapper .swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}
.mobile-wrapper .swiper-slide img {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  min-width: 100%;
  height: 100%;
}
.mobile-wrapper .download {
  position: absolute;
  left: 50%;
  bottom: 102px;
  margin-left: -87px;
  background: url('../../../assets/img/mobile/download.png') no-repeat;
  background-size: contain;
  width: 174px;
  height: 44px;
}
.mobile-wrapper .download a {
  display: block;
  height: 100%;
}
.mobile-wrapper .next {
  position: absolute;
  left: 50%;
  bottom: 30px;
  margin-left: -10px;
  width: 21px;
  height: 28px;
  background: url('../../../assets/img/mobile/arrow.png') no-repeat;
  background-size: contain;
  cursor: pointer;
  animation: arrow 1.5s ease-out infinite;
}
</style>
